import { getConfig } from "@jti/fe-common";
import type { PvsApiContract } from "@jti/rest-api-types";

import { getIsEvo } from "../../utils";

import { PvsApiEvo } from "./PvsApiEvo";
import { PvsApiLegacy } from "./PvsApiLegacy";

export class PvsApi {
  static init(): PvsApiContract {
    const config = getConfig();

    if (config.USE_EVO_ONLY) {
      return new PvsApiEvo(config.EVO_DOMAIN, config.EVO_TENANT, config["X-RECAPTCHA-ID"]);
    }

    if (getIsEvo(config.PVS_URL)) {
      return new PvsApiEvo(config.PVS_URL, config.PVS_X_DES_AK_TENANT_TOKEN, config["X-RECAPTCHA-ID"]);
    }
    return new PvsApiLegacy(config.PVS_URL, config.PVS_X_DES_AK_TENANT_TOKEN);
  }
}
